{
  "slug": "how-can-i-find-out-my-iq",
  "title": "Comment puis-je connaître mon QI?",
  "description": "Comparez les tests de QI en ligne avec une évaluation professionnelle supervisée et apprenez comment obtenir et interpréter un score cognitif crédible.",
  "summary": "La bonne façon de déterminer votre QI dépend de l’objectif recherché : un test en ligne peut fournir une estimation indicative, tandis que les décisions cliniques, éducatives ou d’admissibilité nécessitent une évaluation supervisée appropriée.",
  "category": "IQ essentials",
  "sections": [
    {
      "heading": "Commencez par la raison pour laquelle vous voulez un score",
      "paragraphs": [
        "La curiosité, la pratique, la planification de l’éducation, l’évaluation clinique et la qualification d’adhésion sont des objectifs différents.Une estimation informelle en ligne peut répondre à une question de curiosité, mais ne peut pas remplacer un instrument professionnel protégé.",
        "Si le résultat peut avoir une incidence sur le traitement, les mesures d’adaptation, la scolarité, l’emploi ou une demande officielle, demandez à un psychologue qualifié ou à l’organisme concerné quels tests et documents il accepte."
      ]
    },
    {
      "heading": "Que chercher dans un test en ligne",
      "paragraphs": [
        "Un test en ligne responsable explique ce qu’il échantillonne, combien de temps il prend, comment les scores de comparaison sont produits et ce qu’il ne peut pas établir, il doit protéger les données personnelles et éviter de prétendre à un diagnostic ou à une précision garantie.",
        "Réalisez l’évaluation en vous reposant, dans un environnement calme, en suivant les règles de chronométrage et en évitant toute aide extérieure. La répétition des mêmes éléments peut créer des effets de pratique. Un résultat obtenu plus tard n’est donc pas automatiquement une meilleure estimation."
      ]
    },
    {
      "heading": "Ce que les tests professionnels ajoutent",
      "paragraphs": [
        "Une évaluation professionnelle utilise une administration normalisée, des matériaux sécurisés, des normes d'âge appropriées, de multiples sous-tests et des observations comportementales.Le rapport qui en résulte peut inclure des scores d'indice, des intervalles de confiance et l'interprétation des différences significatives.",
        "Demandez le nom de l'instrument et son édition, le groupe de normes, le type de score, l'intervalle de confiance et les limites.Conserver le rapport original si vous avez besoin plus tard d'une preuve d'un résultat qualifiant."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Un test en ligne gratuit peut-il me dire mon QI exact?",
      "answer": "Il peut fournir une estimation indicative s'il est bien conçu, mais il ne peut pas établir un score exact, permanent ou clinique."
    },
    {
      "question": "Qui peut administrer un test de QI officiel?",
      "answer": "Les tests cliniques normalisés sont généralement administrés et interprétés par des professionnels dûment qualifiés, et les résultats sont généralement disponibles en ligne."
    }
  ],
  "related": ["is-an-online-iq-test-accurate", "how-is-iq-measured", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "Dictionnaire APA de psychologie — test d'intelligence",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Pearson — WAIS-5 Rapport de score d'échantillon",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    },
    {
      "label": "Mensa International — faites tester votre QI",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
